import Color from 'color';

/**
 * COLOR Utilities
 */
export const isHSLColorString = (colorValue) => {
  const regex = /^hsl\(\s*(\d{1,2}|[1-2]\d{2}|3[0-5]\d|\b0\b)\s*,\s*(100%|\d{1,2}%)\s*,\s*(100%|\d{1,2}%)\s*\)$/;
  return (colorValue || '').match(regex);
};

export const isRGBColorString = (colorValue) => {
  const regex =
    /^rgb\(\s*(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\s*,\s*(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\s*,\s*(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\s*\)$/;
  return (colorValue || '').match(regex);
};

export const isHexColorString = (colorValue) => {
  const regex = /^#([0-9A-Fa-f]{3}){1,2}$/;
  return (colorValue || '').match(regex);
};

export const convertToHex = (colorValue) => {
  if (isRGBColorString(colorValue)) {
    return rgb2hex(parseRGB(colorValue));
  }
  if (isHSLColorString(colorValue)) {
    return hsl2hex(parseHSL(colorValue));
  }
  return colorValue.toLowerCase();
};

export const parseHSL = (hslString) => {
  const regex = /hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/;
  const match = hslString.match(regex);
  if (match) {
    const h = parseInt(match[1], 10);
    const s = parseInt(match[2], 10);
    const l = parseInt(match[3], 10);
    return { h, s, l };
  }

  return null;
};

export const parseRGB = (rgbString) => {
  const regex = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
  const match = rgbString.match(regex);
  if (match) {
    const r = parseInt(match[1], 10);
    const g = parseInt(match[2], 10);
    const b = parseInt(match[3], 10);
    return { r, g, b };
  }

  return null;
};

export const parseColorString = (colorString) => {
  if (isHSLColorString(colorString)) {
    return parseHSL(colorString);
  } else if (isRGBColorString(colorString)) {
    return parseRGB(colorString);
  } else if (isHexColorString(colorString)) {
    return colorString.toLowerCase();
  }
  return null;
};

export const hsl2hex = ({ h, s, l }) => {
  const color = Color({ h, s, l });
  return color.hex().toLowerCase();
};

export const rgb2hex = ({ r, g, b }) => {
  const color = Color({ r, g, b });
  return color.hex().toLowerCase();
};

export const hsl2rgb = ({ h, s, l }) => {
  const { r, g, b } = Color({ h, s, l }).rgb().object();

  return {
    r: Math.round(r),
    g: Math.round(g),
    b: Math.round(b),
  };
};

export const rgb2hsl = (r, g, b) => {
  const { h, s, l } = Color({ r, g, b }).hsl().object();
  return {
    h: Math.round(h),
    s: Math.round(s),
    l: Math.round(l),
  };
};

export const isValidColorString = (colorString) => {
  return isHSLColorString(colorString) || isRGBColorString(colorString) || isHexColorString(colorString);
};

export const checkHSLLightness = (color) => {
  if (!color) return false;
  const l = Color(color).hsl().color[2];
  return Math.round(l) <= 45;

  //return Color(color).isDark();
  //color[0] * 0.299 + color[1] * 0.587 + color[2] * 0.114 > 186
};
